module.exports = __webpack_public_path__ + "img/logo_text.dae71e59.png";